import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import { Provider } from 'react-redux'
import store from './store';
import { PrimeReactProvider } from 'primereact/api';

// Suppress third-party library findDOMNode deprecation warnings in development
if (process.env.NODE_ENV === 'development') {
  const filterWarning = (origFn) => (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('findDOMNode is deprecated')) {
      return;
    }
    origFn.apply(console, args);
  };
  console.error = filterWarning(console.error);
  console.warn = filterWarning(console.warn);
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense>
    <Provider store={store}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </Provider>
  </Suspense>
);



